module.exports = __webpack_public_path__ + "static/img/node-bg.40947348.png";